import styled from 'styled-components'
import { Row } from 'antd'

export const StyledAboutUsWrapper = styled(Row)`
  background-image: url('/images/about-us/sauce-bg.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;

  margin-top: -130px;
  height: 100%;
  padding: 130px 50px 25px 50px;

  h1 {
    color: var(--cognac);
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    padding: 95px 25px 25px 25px;
    background-size: auto;
    background-position: top;
  }
`
export const StyledAboutUsTitle = styled.h1`
  color: var(--cognac);
  text-align: center;
`
export const StyledParagraph = styled.p``
